import axios from 'axios';

export const loadData = async () => {
  const insideData = await axios.get('https://www.canada.ca/content/dam/ircc/documents/json/data-ptime-non-country-en.json');
  const outsideData = await axios.get('https://www.canada.ca/content/dam/ircc/documents/json/data-ptime-en.json');
  
  return {
    insideData: insideData.data,
    outsideData: outsideData.data
  };
};
